
<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title>{{'key-management.export-d3e-keys-dialog.title' | translate}}</h2>

<mat-dialog-content>

    <div class="form-container">
        <mat-checkbox [(ngModel)]="encrypt">{{'key-management.export-d3e-keys-dialog.encrypt-keys' | translate}}</mat-checkbox>
        <div class="password-inputs">
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>{{'LI_PASSWORD' | translate}}</mat-label>
                    <span style="display: flex;">
                      <input matInput [disabled]="!encrypt" type="password" name="encryption-password" [(ngModel)]="password"
                              id="newPassInput"
                              (capsLock)="onCapsLockNewChanged($event)"
                              (focus)="passwordFocus($event.target?.id)"
                              (blur)="passwordBlur()"
                              (input)="tooltipNew?.show()">
                      @if (capsOnNew) {
                        <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                                #tooltipNew="matTooltip"
                                matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right">
                        </mat-icon>
                      }
                    </span>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>{{'CONFIRM' | translate}}</mat-label>
                    <span style="display: flex;">
                      <input matInput [disabled]="!encrypt" type="password" name="encryption-password-confirm" [(ngModel)]="confirm"
                              id="confirmPassInput"
                              (capsLock)="onCapsLockConfirmChanged($event)"
                              (focus)="passwordFocus($event.target?.id)"
                              (blur)="passwordBlur()"
                              (input)="tooltipConfirm?.show()">
                      @if (capsOnConfirm) {
                        <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                                  #tooltipConfirm="matTooltip" matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}"
                                  matTooltipPosition="right">
                        </mat-icon>
                      }
                    </span>
                </mat-form-field>
            </div>
        </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClickCancel()">{{'CANCEL' | translate}}</button>
    <button mat-raised-button [disabled]="disableOKButton" (click)="onClickOK()">{{'OK' | translate}}</button>
</mat-dialog-actions>
